import { render, staticRenderFns } from "./ProofWidget.vue?vue&type=template&id=9759e9e4&"
import script from "./ProofWidget.vue?vue&type=script&lang=js&"
export * from "./ProofWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProofWidget.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports